import { render } from "./ImportMapEdit.vue?vue&type=template&id=5164c050"
import script from "./ImportMapEdit.vue?vue&type=script&lang=js"
export * from "./ImportMapEdit.vue?vue&type=script&lang=js"

import "./ImportMapEdit.vue?vue&type=style&index=0&id=5164c050&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.16.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__